export const iconFontAwesomeUsersPeoplePersonSwimming = (
	<i className="fa-solid fa-person-swimming"></i>
);
